import React from 'react';

var styles = { "wrapper": "jvywaxi43BZDH", "wrapper__loader": "jvywaxi42Fphr", "loader": "jvywaxi41D419", "loader__svg": "jvywaxi41jbGf", "svg": "jvywaxi41AMX9", "rotate": "jvywaxi43XPQq", "svg__circle": "jvywaxi4Dukqr", "dash": "jvywaxi43Nbi9" };

var Loader = function Loader() {
  return React.createElement(
    'div',
    { className: styles.wrapper },
    React.createElement(
      'div',
      { className: [styles['wrapper__loader'], styles.loader].join(' ') },
      React.createElement(
        'svg',
        { className: [styles['loader__svg'], styles.svg].join(' '), viewBox: '25 25 50 50' },
        React.createElement('circle', { className: styles['svg__circle'], cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '2', strokeMiterlimit: '10' })
      )
    )
  );
};

export { Loader };
//# sourceMappingURL=index.es.js.map
